import { createAction } from 'redux-actions';

import * as types from './types';

export const uploadStart = createAction(types.UPLOAD_START);
export const uploadStop = createAction(types.UPLOAD_STOP);
